<template>
  <div class="thankyou-wrapper animate fadeIn">
    <component :is="template" v-bind="props" v-if="invoice && !loading" />
  </div>
</template>

<script>
  import Loader from '@/components/Loader'
  import ThankYouBase from '@/components/templates/thank-you/base'

  export default {
    name: 'ThankYou',

    components: {
      Loader
    },

    data () {
      return {
        invoice: null,
        loading: false,
        template: null,
        props: {
          invoice: null,
          product: null
        }
      }
    },

    created () {
      this.fetch()
    },

    methods: {
      fetch () {
        this.loading = true
        const orderId = this.$route.params.orderId
        this.$http.get(`invoices/${orderId}`)
        .then(resp => {
          this.invoice = resp.body

          const products = this.invoice.invoice_product_list
          if (products.length === 0) {
            this.loading = false
            return
          }

          return this.$http.get(`products/${products[0].product_sku}`).then(resp => {
            return {
              template: resp.body.template,
              product: products[0]
            }
          })
        }).then(template => {
          this.loading = false
          return this.getTemplate(template)
        })
        .catch(err => {
          console.log(err)
          this.loading = false
        })
      },

      getTemplate (data) {
        if (!data) {
          return
        }

        this.props.product = data.product
        this.props.invoice = this.invoice
        this.template = ThankYouBase
      }
    }
  }
</script>

<style scoped lang="scss">
.thankyou-wrapper {
  background: rgb(252,186,62); /* Old browsers */
  background: -moz-linear-gradient(top, rgba(252,186,62,1) 0%, rgba(243,137,0,1) 100%); /* FF3.6-15 */
  background: -webkit-linear-gradient(top, rgba(252,186,62,1) 0%,rgba(243,137,0,1) 100%); /* Chrome10-25,Safari5.1-6 */
  background: linear-gradient(to bottom, rgba(252,186,62,1) 0%,rgba(243,137,0,1) 100%); /* W3C, IE10+, FF16+, Chrome26+, Opera12+, Safari7+ */
}

@media all and (max-width: 767px) {

}

</style>



// WEBPACK FOOTER //
// ThankYou.vue?d5e32de8